<div class="flex flex-column">
  <div class="col-12 px-0 py-0 align-items-center flex flex-wrap">
    <label class="col-12 lg:col-3 px-0 lg:py-0 m-0" for="document">{{screen.labels.document}}</label>
    <div class="col-12 lg:col-9 px-0 py-0 inline-flex flex-wrap">
      <span class="col-12 md:col-4 py-0 px-0 md:pr-2 lg:px-2">
        <p-dropdown name="documentTypeCode" [options]="documentTypes" [(ngModel)]="value.documentType"
          [placeholder]="screen.labels.pickOnPlaceholder" class="no-margin" (onChange)="verifyPersonUniqueness()"
          optionLabel="name" optionValue="id" appendTo="body" validation customName="Tipo de Documento"
          [required]="true">
        </p-dropdown>
      </span>
      <span class="col-12 md:col-8 pb-0 pt-2 md:pt-0 px-0 md:pl-2">
        <input pInputText type="text" name="document" [(ngModel)]="value.document" class="no-margin" autocomplete="off"
          [placeholder]="screen.labels.documentPlaceholder" (blur)="verifyPersonUniqueness()" validation
          [required]="value.documentType === 'doc_type_id'" />
      </span>
    </div>
  </div>

  <div class="col-12 px-0 pb-0 pt-2 lg:pt-3 align-items-center flex flex-wrap">
    <label class="col-12 lg:col-3 px-0 lg:py-0 m-0" for="names">{{screen.labels.name}}</label>
    <span class="col-12 lg:col-9 py-0 md:py-0 px-0 lg:pl-2">
      <input pInputText type="text" name="names" [(ngModel)]="value.names" autocomplete="off" validation
        [required]="true" [placeholder]="screen.labels.firstNamePlaceholder" class="uppercase no-margin" />
    </span>
  </div>

  <div class="col-12 px-0 pb-0 pt-2 lg:pt-3 align-items-center flex flex-wrap">
    <label class="col-12 lg:col-3 px-0 lg:py-0 m-0" for="lastnames">{{screen.labels.lastName}}</label>
    <span class="col-12 lg:col-9 py-0 md:py-0 px-0 lg:pl-2">
      <input pInputText type="text" name="lastnames" [(ngModel)]="value.lastnames" autocomplete="off" validation
        [required]="true" [placeholder]="screen.labels.firstLastNamePlaceholder" class="uppercase no-margin" />
    </span>
  </div>

  <div class="col-12 px-0 pb-0 pt-2 lg:pt-3 align-items-center flex flex-wrap">
    <label class="col-12 lg:col-3 px-0 lg:py-0 m-0 field__label">{{screen.labels.born}}</label>
    <div class="col-12 lg:col-9 px-0 py-0 inline-flex flex-wrap">
      <span class="col py-0 pl-0 lg:pl-2 pr-2 person__location-born">
        <p-autoComplete name="locationBornCode" [(ngModel)]="locationBornHelp" [suggestions]="locations"
          [dropdown]="true" [forceSelection]="true" field="label" dataKey="value" inputStyleClass="uppercase"
          [placeholder]="screen.labels.locationBornPlaceholder" (completeMethod)="queryLocations($event.query)"
          (onSelect)="value.locationBorn = $event.value.id" (ngModelChange)="verifyLocationBorn()" appendTo="body">
        </p-autoComplete>
      </span>
      <span class="col-fixed py-0 pl-2 pr-0 person__date-born" [style.width.px]="175">
        <dx-date-box name="dateBorn" [value]="value.dateBorn!" [placeholder]="screen.labels.datePlaceholder"
          [showClearButton]="true" (onValueChanged)="onValueChanged($event)"
          [displayFormat]="screen.labels.dateFormatFull" [useMaskBehavior]="true" type="date"
          [elementAttr]="{ style: { zIndex: 9999 } }">
        </dx-date-box>
      </span>
    </div>
  </div>

  <div class="col-12 px-0 pb-0 pt-2 lg:pt-3 align-items-center flex flex-wrap">
    <label class="col-12 lg:col-3 px-0 lg:py-0 m-0 field__label">{{screen.labels.additional}}</label>
    <div class="col-12 lg:col-9 px-0 py-0 inline-flex flex-wrap">
      <span class="col-12 md:col-6 py-0 md:py-0 px-0 md:pr-2 lg:px-2">
        <p-dropdown name="genderCode" [options]="genders" [(ngModel)]="value.gender"
          [placeholder]="screen.labels.pickOnPlaceholder" optionLabel="name" optionValue="id" class="no-margin"
          appendTo="body">
        </p-dropdown>
      </span>
      <span class="col-12 md:col-6 pb-0 pt-2 md:pt-0 px-0 md:pl-2">
        <p-dropdown name="maritalStatusCode" [options]="maritalStatus" [(ngModel)]="value.maritalStatus"
          [placeholder]="screen.labels.pickOnPlaceholder" optionLabel="name" optionValue="id" class="no-margin"
          appendTo="body">
        </p-dropdown>
      </span>
    </div>
  </div>

  <div class="col-12 px-0 pb-0 pt-2 lg:pt-3 align-items-center flex flex-wrap">
    <label class="col-12 lg:col-3 px-0 lg:py-0 m-0 field__label"
      [ngClass]="{ 'align-self-start': (value.emailHelp && value.emailHelp!.length > 1) || (value.phoneHelp && value.phoneHelp!.length > 1) }"
      [style.margin]="(value.emailHelp && value.emailHelp!.length > 1) || (value.phoneHelp && value.phoneHelp!.length > 1) ? '16px 0 0 ' : ''">
      {{screen.labels.contact}}
    </label>
    <div class="col-12 lg:col-9 px-0 py-0 inline-flex flex-wrap">
      <span class="col-12 md:col-7 py-0 md:py-0 px-0 md:pr-2 lg:px-2">
        <span class="inline-flex flex-column col-12 pb-0 px-0" *ngFor="let email of value.emailHelp; let idx = index"
          [ngClass]="{ 'pt-0': idx === 0, 'pt-2 md:pt-3': idx > 0 }">
          <div class="p-inputgroup">
            <input pInputText type="text" name="email_{{idx}}" [(ngModel)]="email.value" autocomplete="off" validation
              [placeholder]="screen.labels.emailPlaceholder" (ngModelChange)="emailChanged()" />
            <button pButton icon="fas fa-trash" type="button" class="p-button-danger" [style.width.px]="38"
              *ngIf="value.emailHelp!.length > 1" (click)="value.emailHelp!.splice(idx, 1);emailChanged()"></button>
            <button pButton icon="fas fa-plus" type="button" class="p-button-success" [style.width.px]="38"
              *ngIf="idx === (value.emailHelp!.length - 1)" (click)="value.emailHelp!.push({})"></button>
          </div>
        </span>
      </span>
      <span class="col-12 md:col-5 pb-0 pt-2 md:pt-0 px-0 md:pl-2">
        <span class="inline-flex flex-column col-12 pb-0 px-0" *ngFor="let phone of value.phoneHelp; let idx = index;"
          [ngClass]="{ 'pt-0': idx === 0, 'pt-2 md:pt-3': idx > 0 }">
          <div class="p-inputgroup">
            <input pInputText type="text" name="phone_{{idx}}" [(ngModel)]="phone.value" autocomplete="off" validation
              [placeholder]="screen.labels.phonePlaceholder" (ngModelChange)="phoneChanged()" />
            <button pButton icon="fas fa-trash" type="button" class="p-button-danger" [style.width.px]="38"
              *ngIf="value.phoneHelp!.length > 1" (click)="value.phoneHelp!.splice(idx, 1);phoneChanged()"></button>
            <button pButton icon="fas fa-plus" type="button" class="p-button-success" [style.width.px]="38"
              *ngIf="idx === (value.phoneHelp!.length - 1)" (click)="value.phoneHelp!.push({});"></button>
          </div>
        </span>
      </span>
    </div>
  </div>
</div>